const defaults = { region: 'Region', area: 'Area', block: 'Block', zone: 'Zone' };

// tier index in the country's hierarchyTemplate (geo tenants)
const geoTierIndex = { region: 0, area: 1, block: 2 };

/**
 * Returns the label for a location type. Precedence: tenant-set alias, then (on
 * geo tenants) the country's own hierarchy tier name synced by config-loader
 * (e.g. Kuwait: Governorate/Area/Block, Saudi: Region/Governorate/District),
 * then the generic default.
 * @param {'region'|'area'|'block'|'zone'} key
 * @returns {string}
 */
export function locationLabel(key) {
  try {
    const config = JSON.parse(localStorage.getItem('LOCATION_CONFIG') || '{}');
    const alias = config[key + 'Alias'];
    if (alias) return alias;
    if (config.useGeoLocations === true && Array.isArray(config.geoTierLabels) && key in geoTierIndex) {
      const label = config.geoTierLabels[geoTierIndex[key]];
      if (label) return label;
    }
    return defaults[key] || key;
  } catch (e) {
    return defaults[key] || key;
  }
}

/**
 * True when this tenant is on the geo location system (locations synced from the
 * SaaS master store). Set automatically the first time a country is loaded.
 * Gates the Delivery Locations page and hides the legacy Governorate/Area/Block
 * screens it replaces. NOTE: locationConfig.locationMode is unrelated — it holds a
 * country name for the legacy screens.
 * @returns {boolean}
 */
export function useGeoLocations() {
  try {
    const config = JSON.parse(localStorage.getItem('LOCATION_CONFIG') || '{}');
    return config.useGeoLocations === true;
  } catch (e) {
    return false;
  }
}
